import type { EmailRule } from '@/types/emailRule'
import type { FieldDefinition, FilterGroup } from '@/tableControls'
import { filterRows, matchTerm } from '@/tableControls'
import { foldForSearch } from '@/utils/foldForSearch'

export function getEmailRuleSearchableText(row: EmailRule): string {
  return [row.vendor_name, row.from_filter, row.subject_contains]
    .filter(Boolean)
    .map(String)
    .join(' ')
}

export function filterEmailRulesByText(rows: EmailRule[], query: string): EmailRule[] {
  const trimmed = query.trim()
  if (!trimmed) return rows
  const foldedQuery = foldForSearch(trimmed)
  return rows.filter((row) =>
    matchTerm(foldForSearch(getEmailRuleSearchableText(row)), foldedQuery)
  )
}

export function getEmailRuleFilterValue(
  row: EmailRule,
  fieldKey: string,
  fields: FieldDefinition<EmailRule>[]
): unknown {
  if (fieldKey === 'destination') {
    return row.destinations
  }
  const field = fields.find((entry) => entry.key === fieldKey)
  if (field?.accessor) {
    return field.accessor(row)
  }
  return row[fieldKey as keyof EmailRule]
}

export function filterEmailRulesWithTree(
  rows: EmailRule[],
  filterTree: FilterGroup | null,
  fields: FieldDefinition<EmailRule>[]
): EmailRule[] {
  return filterRows(rows, filterTree, fields, (row, fieldKey) =>
    getEmailRuleFilterValue(row, fieldKey, fields)
  )
}
